import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatDateTime } from '../../../../../common/utils/formatDateTime';
import formatReturns from '../../../../../common/utils/formatReturns';

class BetHistoryListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: true,
        };

        this.toggleExpanded = this.toggleExpanded.bind(this);
    }

    toggleExpanded() {
        this.setState({
            isExpanded: !this.state.isExpanded,
        });
    }

    renderReceipt(selection, i) {
        const { selectionName, odd, eventName } = selection;
        let resultOdd;
        /*
         * Fix for William Hill remove @ / (rpw-663)
         * Fix for Corel replace null for Forecast/Tricast text (rpw-664)
         */
        if (odd === '0/0' || odd === '/') {
            resultOdd = '';
        } else if (odd === null) {
            resultOdd = 'Forecast/Tricast';
        } else if (odd === '1/1') {
            resultOdd = '@ Evs';
        } else {
            resultOdd = `@ ${odd}`;
        }

        return (
            <div
                role="button"
                tabIndex={0}
                className="bs-betHistorySingle__main"
                onClick={this.toggleExpanded}
                key={i}
            >
                <div className="bs-betHistorySingle__info">
                    <div className="bs-betHistorySingle__horse">
                        <span>{selectionName}&nbsp;{ resultOdd }</span>
                    </div>
                    <div className="bs-betHistorySingle__race">
                        <span>{eventName}</span>
                    </div>
                </div>
            </div>
        )
    }

    renderReceiptDetails() {
        const {
            finished,
            receiptId,
            timeBetPlaced,
            betType,
            totalStake,
            returns,
            currencySign,
            win,
            stake,
            selections,
        } = this.props;

        const returnsValue = returns === null
            ? 'N/A'
            : `${currencySign}${formatReturns(returns)}`;
        const eachWay = selections.every(selection => selection.eachWay === true);

        if (!this.state.isExpanded) {
            return null
        }

        return (
            <div className="bs-betHistorySingle__bet">
                <div className="bs-betHistorySingle__betLine">
                    <span>Receipt ID</span>
                    <span>{receiptId}</span>
                </div>
                <div className="bs-betHistorySingle__betLine">
                    <span>Time Bet Placed</span>
                    <span>{formatDateTime(timeBetPlaced)}</span>
                </div>
                <div className="bs-betHistorySingle__betLine">
                    <span>Bet Type</span>
                    <span>
                        <span className="bs-betHistorySingle__betType">{betType} </span>
                        {`${currencySign}${stake.toFixed(2)} `}
                        {eachWay ? 'EW' : 'Win'}
                    </span>
                </div>
                <div className="bs-betHistorySingle__betLine">
                    <span>Total Stake</span>
                    <span>{`${currencySign}${totalStake.toFixed(2)}`}</span>
                </div>
                {
                    finished ? (
                        <div className="bs-betHistorySingle__betLine">
                            <span>Bet Status</span>
                            <span
                                className={classNames(
                                    {
                                        'bs-betHistorySingle__result_win': win,
                                    },
                                )}
                            >
                                {win ? 'Won' : 'Lost'}
                            </span>
                        </div>
                    ) : (
                        <div className="bs-betHistorySingle__betLine">
                            <span>Bet Status</span>
                            <span>-</span>
                        </div>
                    )
                }
                <div className="bs-betHistorySingle__betLine">
                    <span>Returns</span>
                    <span
                        className={classNames(
                            {
                                'bs-betHistorySingle__result_win': finished
                                    && win
                                    && returns !== null,
                            },
                        )}
                    >
                        {returnsValue}
                    </span>
                </div>
            </div>
        )
    }

    render() {
        const {
            selections,
            betType,
        } = this.props;
        const betName = (betType === 'singles') ? 'Single' : betType;

        return (
            <div
                className={classNames(
                    'bs-betHistorySingle',
                    'bs-betHistorySingle_expanded',
                )}
            >
                <h4>{betName}</h4>
                {selections.map((selection, i) => this.renderReceipt(selection, i))}
                {this.renderReceiptDetails()}
            </div>
        )
    }
}

BetHistoryListItem.defaultProps = {
    win: null,
    returns: 0,
};

BetHistoryListItem.propTypes = {
    finished: PropTypes.bool.isRequired,
    receiptId: PropTypes.string.isRequired,
    timeBetPlaced: PropTypes.string.isRequired,
    betType: PropTypes.string.isRequired,
    stake: PropTypes.number.isRequired,
    totalStake: PropTypes.number.isRequired,
    returns: PropTypes.number,
    currencySign: PropTypes.string.isRequired,
    win: PropTypes.bool,
    selections: PropTypes.arrayOf(PropTypes.shape({
        eachWay: PropTypes.bool.isRequired,
        eventName: PropTypes.string.isRequired,
        odd: PropTypes.string.isRequired,
        selectionName: PropTypes.string.isRequired,
    })).isRequired,
};

export default BetHistoryListItem



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/betHistory/components/BetHistoryListItem.jsx